import styled from '@emotion/styled';

const PdfPageStyle = styled('div')`
    background: var(--white);
    color: var(--sand-700);
    padding-bottom: 120px;
    .detail-content {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .box-print + .box-print {
        padding-top: 36px;
    }

    @media screen and (max-width: 767px) {
    }
    // @media print {
    //     .box-print {
    //         page-break-after: always;
    //         &:last-child {
    //             page-break-after: avoid;
    //         }
    //     }
    // }
`;
export default PdfPageStyle;
